<ion-input [value]="value?.name" [readonly]="true" (click)="openProjectTaskSelection()"> </ion-input>
